export * from './IconHeartInHandGradient';
export { default as IconHeartInHandGradient } from './IconHeartInHandGradient';
